/**
 * Returns diff between two dates in hours and minutes, in '0h 0m' format
 * If only first argument provided then it considered as a range
 * @example
 * formatTimeRange(new Date(2014, 0, 1, 20, 00), new Date(2014, 0, 1, 20, 30)) // 30m
 * formatTimeRange(new Date(2014, 0, 1, 20, 00), new Date(2014, 0, 1, 19, 30)) // 1h 30m
 * formatTimeRange(1000 * 60 * 59) // 59m
 */
export default function formatTimeRange(dirtyTimeStart, dirtyTimeEnd) {
  const timeStart = new Date(dirtyTimeStart)
  const timeEnd = dirtyTimeEnd === undefined ? new Date(0) : new Date(dirtyTimeEnd)
  const range = Math.abs(timeEnd - timeStart)

  const minutes = Math.floor(range / 1000 / 60) % 60
  const hours = Math.floor(range / 1000 / 60 / 60)
  const seconds = Math.floor(range / 1000)

  if (hours && minutes) {
    return hours + ' h ' + minutes + ' min'
  } else if (hours) {
    return hours + ' h'
  } else if (minutes) {
    return minutes + ' min'
  } else if (seconds) {
    return 'less than a minute'
  } else {
    return 'immediate'
  }
}



// WEBPACK FOOTER //
// ./client/utils/formatTimeRange.js